<template>
  <vs-popup :active.sync="isActive" id="qrReaderPage">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-type="flex" vs-w="5" class="p-2">
        <div class="w-full text-center img-border p-5">
          <img @click="focusInput" src="@/assets/general/qr-code-scan.svg" class="w-full">
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-w="7" class="p-2">
        <vs-row vs-type="flex" vs-="12">
          <vs-row vs-type="flex" vs-w="12">
            <span class="text-medium text-dark weight-600">
              Qr Kodu Tarayabilirsiniz
            </span>
          </vs-row>
          <vs-row v-if="isWallet" vs-type="flex" vs-w="12">
            <span class="text-medium text-dark weight-600">
              Ödenecek tutar {{ amount }} TL
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <span class="text-xsmall text-secondary weight-500">
              Qr Kod doğru şekilde taratıldıktan sonra ekran kendini kapatacaktır.
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <span class="text-smaller text-dark weight-600">
              Taramak yapmak yerine 10 haneli Kod ile de müşteriyi tanımlayabilirsiniz.
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <input autocomplete="off" id="qrCode" name="Qr Kod" ref="qrInput" placeholder="Qr Kod"
              maxlength="10"
              class="w-full text-dark weight-600 text-small border-all border-grey low-border-radius px-2" 
              v-model="displayVal" @input="handleInput" />
            <span class="text-danger text-xsmaller"
              v-show="errors.has('Qr Kod')">{{ errors.first("Qr Kod") }}</span>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
  import {
    GetCustomerByQr
  } from "@/api/Campaign.js"
  import {
    ReduceFromWallet
} from "@/api/SelfService";
  export default {
    data() {
      return {
        isActive: false,
        qrCode: "",
        customer: null,
        isWallet : false,
        amount : 0,
        isDiscount : null,
        displayVal: "",
        actualVal: "",
        maskTimeout: null
      }
    },
    methods: {
      handleInput(e) {
        const val = e.target.value;
        const diff = val.length - this.actualVal.length;
        if (diff < 0) {
          this.actualVal = this.actualVal.substring(0, val.length);
        } else if (diff > 0) {
          const added = val.substring(val.length - diff);
          this.actualVal += added;
        }
        
        if (this.actualVal.length > 0) {
          const lastChar = this.actualVal.charAt(this.actualVal.length - 1);
          this.displayVal = "*".repeat(this.actualVal.length - 1) + lastChar;
        } else {
          this.displayVal = "";
        }
        
        this.qrCode = this.actualVal;
        
        if (this.maskTimeout) clearTimeout(this.maskTimeout);
        this.maskTimeout = setTimeout(() => {
          this.displayVal = "*".repeat(this.actualVal.length);
        }, 400);
      },
      initValues() {
        this.qrCode = "";
        this.customer = null;
      },
      focusInput() {
        this.$nextTick(() => {
          this.$refs.qrInput.focus()
        })
      },
      GetCustomerByQr() {
        GetCustomerByQr(this.qrCode.toUpperCase()).then(res => {
          if (res && res.status == 200 && res.data != null) {
            if (res.data.qrType === "partner") {
              this.isActive = false;
              this.$emit("partnerSuccess", res.data);
              return;
            }
            this.customer = res.data;
            this.customer.giftQrCode = this.qrCode.toUpperCase();
            this.isActive = false;
            this.$emit("success", this.customer);
          } else {
            this.customer = null;
            this.qrCode = null;
            this.$fire({
              title: "Geçersiz QR Kod",
              text: "Bu alanda yalnızca \"Kasada Mood Toplama\" ve \"Kampanya/İkram\" QR kodu okutulabilmektedir! \"Cüzdan Ödeme\" QR'ını ödeme adımında \"Cüzdan\" seçerek \"Ödeme Al\" işlemi ile ekrana çıkan alanda okutunuz!",
              type: "warning"
            });
            this.$vs.notify({
              color: "warning",
              title: "Geçersiz QR Kod",
              text: "Bu alanda yalnızca \"Kasada Mood Toplama\" ve \"Kampanya/İkram\" QR kodu okutulabilmektedir! \"Cüzdan Ödeme\" QR'ını ödeme adımında \"Cüzdan\" seçerek \"Ödeme Al\" işlemi ile ekrana çıkan alanda okutunuz!"
            });
          }
        }).catch(() => {
          this.customer = null;
          this.qrCode = null;
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      reduceFromWallet(val,amount){
        ReduceFromWallet(val,amount).then(res=>{
          this.customer = res.data;
            this.customer.giftQrCode = this.qrCode;
            this.$emit("success", this.customer);
            this.isActive = false;
              debugger;
              console.log(this.customer);

              this.$emit("reduceSuccess", amount, this.isDiscount);
  })
        .catch(err => {
          this.qrCode = "";
          let errMsg = "";
          if (err.response && err.response.data && err.response.data.Errors && err.response.data.Errors[0]) {
            errMsg = err.response.data.Errors[0].Message;
          } else {
            errMsg = "Bir hata oluştu.";
          }

          if (errMsg && errMsg.toLowerCase().includes("geçersiz qr kod")) {
            const customMsg = 'Bu alanda yalnızca "Cüzdan Ödeme" QR\'ı işlem görmektedir. Lütfen doğru QR kodu okutunuz! (Cüzdan QR\'ı mobil uygulamada QR butonuna bastıktan sonra sol kısımda gelen "Cüzdan Ödeme" seçeneğinden ilerlendiğinde ekrana gelmektedir).';
            this.$fire({
              title: "Geçersiz QR Kod",
              text: customMsg,
              type: "warning"
            });
            this.$vs.notify({
              color: "warning",
              title: "Geçersiz QR Kod",
              text: customMsg
            });
          } else {
            this.$fire({
              title: "Hata !",
              text: errMsg,
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: errMsg
            });
          }
        })
      }
    },
    watch: {
      isActive(val) {
        if (!val) this.initValues();
        else {
          this.focusInput()
        }
      },
      qrCode(val) {
        if (!val) {
          this.actualVal = "";
          this.displayVal = "";
        }
        if (val && val.length == 10) {
          const valUpper = val.toUpperCase();
          if (this.isWallet) {
            if (/^CU\d{8}$/.test(valUpper)) {
              this.reduceFromWallet(valUpper, this.amount);
            } else {
              this.qrCode = "";
              const customMsg = 'Bu alanda yalnızca "Cüzdan Ödeme" QR\'ı işlem görmektedir. Lütfen doğru QR kodu okutunuz! (Cüzdan QR\'ı mobil uygulamada QR butonuna bastıktan sonra sol kısımda gelen "Cüzdan Ödeme" seçeneğinden ilerlendiğinde ekrana gelmektedir).';
              this.$fire({
                title: "Geçersiz QR Kod",
                text: customMsg,
                type: "warning"
              });
              this.$vs.notify({
                color: "warning",
                title: "Geçersiz QR Kod",
                text: customMsg
              });
            }
          } else {
            if (/^(CU|CA|PT|CQ)\d{8}$/.test(valUpper)) {
              this.GetCustomerByQr();
            } else {
              this.qrCode = "";
              this.$fire({
                title: "Geçersiz QR Kod",
                text: "Bu alanda yalnızca \"Kasada Mood Toplama\" ve \"Kampanya/İkram\" QR kodu okutulabilmektedir! \"Cüzdan Ödeme\" QR'ını ödeme adımında \"Cüzdan\" seçerek \"Ödeme Al\" işlemi ile ekrana çıkan alanda okutunuz!",
                type: "warning"
              });
              this.$vs.notify({
                color: "warning",
                title: "Geçersiz QR Kod",
                text: "Bu alanda yalnızca \"Kasada Mood Toplama\" ve \"Kampanya/İkram\" QR kodu okutulabilmektedir! \"Cüzdan Ödeme\" QR'ını ödeme adımında \"Cüzdan\" seçerek \"Ödeme Al\" işlemi ile ekrana çıkan alanda okutunuz!"
              });
            }
          }
        }
      }
    }
  }

</script>

<style>
  #qrReaderPage .vs-popup--header {
    background: none !important;
  }

  #qrReaderPage .vs-popup--header .vs-popup--title h3 {
    display: none;
  }
  .swal2-container {
  z-index: 99999;
}
</style>
